<template>
  <div>
    <page-title
      icon="fas fa-table"
      main="Cadastro"
      sub="Vendedores"
      :help="true"
      titleHelp="Ajuda - Vendedores"
      content="Tela Responsável por vincular vendedores a um Ano Safra e pesquisar vendedores permitindo o filtro destes.
Para criação pressione o botão no canto superior direito 'Adicionar'.
Para alteração de um vendedor basta ir com o mouse em ações e clicar em Editar."
    >
      <template v-slot:actions>
        <base-button
          @click="register(), getModalData()"
          type="neutral"
          class="ml-3"
          size="sm"
          v-if="$can('update', 'user')"
        >Novo Vendedor</base-button>
      </template>
    </page-title>
    <modal :show.sync="modals.modal0" id="cadastrar-grupo" size="lg" @close="closeRegister">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Adicionar Novo</h5>
      </template>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form role="form" @submit.prevent="handleSubmit(save)">
          <div class="row" style="padding-bottom: 10px;">
            <div class="col-12 col-md-6 form-group">
              <label class="form-control-label">Gerente Comercial
                <span class="text-danger">*</span>
              </label>
              <multiselect
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.manager }"
                placeholder="Escolha um Gerente Comercial"
                v-model="anosafra_user.manager"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="managers"
                label="name"
                track-by="id"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label class="form-control-label">Vendedor
                <span class="text-danger">*</span>
              </label>
              <multiselect
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.salesmans }"
                v-model="anosafra_user.salesmans"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="salesmans"
                placeholder="Escolha um vendedor"
                label="name"
                track-by="id"
                @search-change="getSalesmans"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label class="form-control-label">Filial
                <span class="text-danger">*</span>
              </label>
              <multiselect
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.branch }"
                v-model="anosafra_user.branch"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="branches"
                placeholder="Escolha uma Filial"
                label="name"
                track-by="id"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label class="form-control-label">Tipo de Vendedor
                <span class="text-danger">*</span>
              </label>
              <multiselect
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.selected_type }"
                v-model="anosafra_user.selected_type"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="types"
                placeholder="Tipo de Vendedor"
                label="name"
                :selected-label="'Selecionado'"
                track-by="code"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <label class="form-control-label">Segmento
                <span class="text-danger">*</span>
              </label>
              <multiselect
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.channel }"
                v-model="anosafra_user.channel"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="channels"
                placeholder="Tipo de Segmento"
                label="description"
                track-by="id"
                @search-change="getSalesmans"
              />
            </div>
            <div class="col-12 col-md-6 form-group">
              <anosafra-multiselect
                v-model="anosafra_user.anosafra"
                label="Ano Safra"
                required="true"
                filterable
                :searchable="true"
                :class="{ 'required-multiselect': errorMessage && !anosafra_user.anosafra }"
              />
            </div>
            <span class="ml-3 text-danger">{{ errorMessage }}</span>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button
          type="secondary"
          class="mr-2"
          @click="closeRegister"
          >Fechar</base-button
        >
        <base-button type="success" @click="save"
          >Salvar</base-button
        >
      </template>
    </modal>
    <modal :show.sync="modals.modal1" id="editar-grupo" size="lg" @close="closeEdit">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Editar Vendedor</h5>
      </template>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form role="form" @submit.prevent="handleSubmit(edit)">
          <div class="row" style="padding-bottom: 10px;">
            <div class="col-6 form-group">
              <label class="form-control-label">Gerente Comercial
                <span class="text-danger">*</span>
              </label>
              <multiselect
                placeholder="Escolha um Gerente Comercial"
                v-model="anosafra_user.manager"
                filterable
                :searchable="true"
                :close-on-select="true"
                :options="managers"
                label="name"
                rules="required"
                track-by="id"
              >
              </multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Vendedor
                <span class="text-danger">*</span>
              </label>
              <multiselect
                v-model="anosafra_user.salesmans"
                filterable
                rules="required"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :searchable="true"
                :close-on-select="true"
                :options="salesmans"
                placeholder="Escolha um vendedor"
                label="name"
                track-by="id"
              ></multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Filial
                <span class="text-danger">*</span>
              </label>
              <multiselect
                v-model="anosafra_user.branch"
                filterable
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :searchable="true"
                :close-on-select="true"
                :options="branches"
                placeholder="Escolha uma Filial"
                label="name"
                track-by="id"
                rules="required"
              ></multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Tipo de Vendedor
                <span class="text-danger">*</span>
              </label>
              <multiselect
                v-model="selected_type"
                filterable
                :searchable="true"
                :close-on-select="true"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="types"
                placeholder="Tipo de Vendedor"
                label="name"
                track-by="code"
                rules="required"
              ></multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Segmento
                <span class="text-danger">*</span>
              </label>
              <multiselect
                v-model="anosafra_user.channel"
                filterable
                :searchable="true"
                :close-on-select="true"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :options="channels"
                placeholder="Tipo de Segmento"
                label="description"
                track-by="code"
                rules="required"
              ></multiselect>
            </div>
            <span class="ml-3 text-danger">{{ errorMessage }}</span>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button
          type="secondary"
          @click="closeEdit"
          >Fechar</base-button
        >
        <base-button type="success" @click="edit"
          >Salvar e Continuar</base-button
        >
      </template>
    </modal>
    <!-- Filters -->
    <card>
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Pesquisar vendedores</h5>
        </div>
      </div>
      <filters @filter="search"></filters>
    </card>

    <!-- Data -->
    <card>
      <template>
        <div style="overflow-x: auto;">
          <el-table
            empty-text="Nenhum registro encontrado."
            class="table-responsive table-striped clickable-rows"
            header-row-class-name="thead-light"
            style="padding-top: 10px; min-width: 900px;"
            :data="anosafra_users"
            max-height="500"
            ref="anosafra_users"
          >
            <el-table-column
              label="Ano Safra"
              :min-width="18"
              prop="anosafra.descricao"
              sortable
            ></el-table-column>
            <el-table-column
              label="Vendedor"
              :min-width="40"
              prop="salesmans.name"
              sortable
            >
              <template slot-scope="scope">
                <el-popover placement="top" trigger="hover">
                  <div class="el-popover__title">Dados do Vendedor</div>
                  <div v-if="scope.row.salesman_id">
                    <strong>Código SGV:</strong> {{ scope.row.salesman_id }}<br />
                  </div>
                  <div v-if="scope.row.salesmans && scope.row.salesmans.email">
                    <strong>Email:</strong> {{ scope.row.salesmans.email }}<br />
                  </div>
                  <div v-if="scope.row.coordinator && scope.row.coordinator.name">
                    <strong>Coordenador:</strong> {{ scope.row.coordinator.name
                    }}<br />
                    <strong>Email Coordenador:</strong>
                    {{ scope.row.coordinator.email }}<br />
                  </div>

                  <div slot="reference">
                    {{ scope.row.salesmans ? scope.row.salesmans.name : "-" }}
                  </div>
                </el-popover>
                <div 
                  v-if="scope.row.has_client_in_erp"
                  class="text-warning mr-3"
                  style="font-size: 12px; max-width: 280px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                >
                  <i class="fa fa-exclamation-triangle mr-1"></i>Vendedor possui clientes vinculados no ERP
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Gerente Comercial"
              :min-width="25"
              prop="manager.name"
              sortable
            >
              <template slot-scope="scope">
                <el-popover placement="top" trigger="hover">
                  <div class="el-popover__title">Dados do Gerente Comercial</div>
                  <div v-if="scope.row.manager_id">
                    <strong>Código SGV:</strong> {{ scope.row.manager_id }}<br />
                  </div>
                  <div v-if="scope.row.manager && scope.row.manager.email">
                    <strong>Email:</strong> {{ scope.row.manager.email }}<br />
                  </div>

                  <div slot="reference">
                    {{ scope.row.manager ? scope.row.manager.name : "-" }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="Filial"
              :min-width="19"
              prop="branch.name"
              sortable
            ></el-table-column>
            <el-table-column
              label="Tipo"
              :min-width="18"
              prop="salesman_type"
              v-slot="{ row }"
              sortable
            >
              <span v-if="row.salesman_type">{{
                row.salesman_type.toUpperCase()
              }}</span>
            </el-table-column>
            <el-table-column
              label="Segmento"
              :min-width="18"
              prop="channel.description"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="Ações"
              :min-width="10"
              prop="acoes"
              v-slot="{ row }"
              v-if="$can('update', 'user')"
            >
              <div class="row">
                <el-dropdown
                  trigger="hover"
                  class="dropdown"
                  style="cursor: pointer;"
                >
                  <span class="btn btn-sm btn-icon-only text-success">
                    <i class="fa fa-ellipsis-v mt-2"></i>
                  </span>
                  <el-dropdown-menu
                    class="dropdown-menu dropdown-menu-arrow show"
                    slot="dropdown"
                  >
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="setAttributes(row), getModalData()"
                      >Editar</a
                    >
                    <a class="dropdown-item" href="#" @click="remove(row)"
                      >Excluir</a
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import Filters from "./components/Filters";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Popover,
  Dropdown,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import { Select, Option, Loading } from "element-ui";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import swal from "sweetalert2";
import { ValidationProvider, extend } from "vee-validate";

extend("required", isValid => {
  if(isValid){
    return true
  }
  return "Este campo é obrigatório";
});
export default {
  name: "app",
  components: {
    Multiselect,
    AnosafraMultiselect,
    Filters,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PageTitle,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Popover.name]: Popover,
  },
  data() {
    return {
      active: true,
      modals: {
        modal0: false,
        modal1: false,
      },
      anosafra_users: [],
      anosafra_user: {},
      paginated_data: {},
      filterData: null,
      anosafras: [],
      managers: [],
      salesmans: [],
      coordinators: [],
      branches: [],
      channels: [],
      channel: {},
      types: [
        { code: "campo", name: "Campo" },
        { code: "balcao", name: "Balcão" },
        { code: "redistribuicao", name: "Redistribuição" },
      ],
      attributes: {},
      anosafraUserBeforeUpdate: {},
      loadingEdit: false
    };
  },
  mounted() {
    if (this.$can("index", "user")) {
      this.getCoordinators();
    }
    this.getData();
    this.getChannels();
    this.getSalesmans();
  },
  methods: {
    setError(error, text) {
      console.error("[Filters][setError]", error)
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setAttributes(item) {
      this.anosafra_user = item;
      this.modals.modal1 = true;
      this.anosafraUserBeforeUpdate = item;
    },
    closeRegister(){
      this.anosafra_user = {};
      this.errorMessage = "";
      this.modals.modal0 = false;
    },
    closeEdit(){
      this.anosafra_user = {};
      this.errorMessage = "";
      this.modals.modal1 = false;
    },
    save() {
      if (
          !this.anosafra_user.anosafra ||
          !this.anosafra_user.salesmans ||
          !this.anosafra_user.manager ||
          !this.anosafra_user.branch ||
          !this.anosafra_user.selected_type ||
          !this.anosafra_user.channel
        ) {
          this.errorMessage = 'Por favor, preencha todos os campos obrigatórios.';
          return;
        }
      const item = {
        anosafra_id: this.anosafra_user.anosafra.id,
        salesman_id: this.anosafra_user.salesmans.id,
        manager_id: this.anosafra_user.manager.id,
        // coordinator_id: this.anosafra_user.coordinator.id,
        branch_id: this.anosafra_user.branch.id,
        salesman_type: this.anosafra_user.selected_type.code,
        channel_id: this.anosafra_user.channel && this.anosafra_user.channel.id,
      };

      this.$http.secured
        .post("/api/v1/anosafra_user", { anosafra_user: item })
        .then((response) => {
          this.$toasted.global.defaultSuccess();
          this.modals.modal0 = false;
          window.location.reload();
        })
        .catch((error) => console.log(error));
    },
    async edit() {
      this.loadingEdit = true;
      try {
        const isValid = await this.$refs.formValidator.validate();
        if (!isValid) {
          this.$toasted.global.defaultError({
            msg: "Por favor, preencha todos os campos obrigatórios.",
          });
          this.loadingEdit = false;
          return;
        }

        const item = {
          anosafra_id: this.anosafra_user.anosafra && this.anosafra_user.anosafra.id || null,
          salesman_id: this.anosafra_user.salesmans && this.anosafra_user.salesmans.id || null,
          manager_id: this.anosafra_user.manager && this.anosafra_user.manager.id || null,
          coordinator_id: this.anosafra_user.coordinator && this.anosafra_user.coordinator.id || null,
          branch_id: this.anosafra_user.branch && this.anosafra_user.branch.id || null,
          salesman_type: this.selected_type && this.selected_type.code || null,
          channel_id: this.anosafra_user.channel && this.anosafra_user.channel.id || null,
        };

        if (this.anosafraUserBeforeUpdate.salesman_type === "campo" && this.anosafra_user.salesman_type === "balcao") {
          const result = await swal.fire({
            title: `Deseja remover a carteira de clientes desse vendedor?`,
            text: "A carteira de clientes do vendedor informado no presente ano safra será deletada",
            buttonsStyling: false,
            icon: "info",
            showCancelButton: true,
            cancelButtonClass: "btn btn-warning",
            cancelButtonText: "Fechar",
            confirmButtonClass: "btn btn-success mr-2",
            confirmButtonText: "Confirmar",
          });

          if (result.isConfirmed) {
            this.getSalesmanRegion(this.anosafra_user.salesman_id);
            await this.$http.secured.put(`/api/v1/anosafra_user/${this.anosafra_user.id}`, item);
            this.$toasted.global.defaultSuccess();
            this.modals.modal1 = false;

            const updatedItemIndex = this.anosafra_users.findIndex(
              (anosafraUser) => anosafraUser.id === this.anosafra_user.id
            );
            this.$set(this.anosafra_users, updatedItemIndex, {
              ...this.anosafra_user,
              ...item,
            });
            this.getData(this.filterData, this.paginated_data.current);
          }
        } else {
          await this.$http.secured.put(`/api/v1/anosafra_user/${this.anosafra_user.id}`, item);
          this.$toasted.global.defaultSuccess();
          this.modals.modal1 = false;

          const updatedItemIndex = this.anosafra_users.findIndex(
            (anosafraUser) => anosafraUser.id === this.anosafra_user.id
          );
          this.$set(this.anosafra_users, updatedItemIndex, {
            ...this.anosafra_user,
            ...item,
          });
          this.getData(this.filterData, this.paginated_data.current);
        }
      } catch (error) {
        console.error("[Salesman][edit]", error);
        this.$toasted.global.defaultError();
      } finally {
        this.loadingEdit = false;
      }
    },
    removeClienRegions(clientRegionId) {
      const data = {
        id: clientRegionId
      }

      this.$http.secured.delete(`/api/v1/client_regions/${clientRegionId}`, data)
      .catch((error) => console.error('Error: remove client regions', error));
    },
    remove(item) {
      if (confirm("Deseja excluir este registro?")) {
        this.$http.secured
          .delete(`/api/v1/anosafra_user/${item.id}`)
          .then((response) => {
            this.$toasted.global.defaultSuccess();
            this.getData(this.filterData, null);
          })
          .catch((error) =>
            this.setError(error, "Não pode apagar esse registro")
          );
      }
    },
    register() {
      this.anosafra_user = {};
      this.modals.modal0 = true;
    },
    changePage(page) {
      this.getData(this.filterData, page);
    },
    getData(q, page) {
      this.$http.secured
        .get("/api/v1/anosafra_user", {
          params: {
            page: page,
            q: q,
            check_has_client: true
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.anosafra_users = this.paginated_data["anosafra_users"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getSalesmanRegion(salesman_id) {
      this.$http.secured.get("/api/v1/client_regions", {
        params: {
          q: {
            salesman_id: salesman_id
          },
          anosafra_id: this.anosafra_user.anosafra_id
        },
      })
      .then((response) => {
        const client_regions = response.data;
        if (client_regions == []) return

        client_regions.map((client_region) => {
          this.removeClienRegions(client_region.id)
        })
      })
      .catch((error) => {
        console.error('Error: get client_regions', error)
        this.$toasted.global.defaultError({msg: 'Erro ao remover carteira de clientes!'})
      });
    },
    search(filter) {
      this.filterData = filter;
      this.getData(filter, null);
    },
    getManagers() {
      this.$http.secured
        .get("/api/v1/users/", {
          params: {
            unpaged: true,
            q: { is_manager: true }
          },
        })
        .then((response) => {
          this.managers = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getBranches() {
      this.$http.secured
        .get("/api/v1/branches/")
        .then((response) => {
          this.branches = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getSalesmans(search = "") {
      this.$http.secured
        .get("/api/v1/getsalesmans", {
          params: {
            name_only: true,
            not_anosafra: true,
            unscoped: true,
            q: { name: search },
          },
        })
        .then((response) => {
          this.salesmans = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getCoordinators() {
      this.$http.secured
        .get("/api/v1/users", {
          params: {
            is_coordinator: true
    
          },
        })
        .then((response) => {
          this.coordinators = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getTypes() {
      this.types = [
        {
          code: "campo",
          salesman_type: "CAMPO",
        },
        {
          code: "balcao",
          salesman_type: "BALCÃO",
        },
        {
          code: "redistribuicao",
          salesman_type: "REDISTRIBUIÇÃO",
        },
      ];
    },
    getChannels() {
      this.$http.secured
        .get("/api/v1/channels/")
        .then((response) => this.channels = response.data)
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getModalData() {
      this.getManagers();
      this.getSalesmans();
      this.getBranches();
      this.getChannels();
    },
  },
  computed: {
    selected_type: {
      get() {
        return (
          this.types.find(
            (type) => type.code == this.anosafra_user.salesman_type
          ) || {}
        );
      },
      set(newVal) {
        this.anosafra_user = Object.assign({}, this.anosafra_user, {
          salesman_type: newVal.code,
        });
      },
    },
  },
  watch: {
    "anosafra_user.manager": function () {
      this.getSalesmans();
    },
  },
};
</script>
<style>
.required-multiselect .multiselect__input {
  border-color: red;
}

.required-multiselect .multiselect__input::after {
  content: "*";
  color: red;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-10%);
}

.required-multiselect .multiselect__input.is-focused {
  border-color: red;
}

.required-multiselect .multiselect__tags {
  border-color: red;
}

</style>
